export const messages = {
  en: {
    indexMenu: {
      search: {
        title: 'Search Conditions',
        name: 'Menu Name',
        isShow: 'Display Status'
      },
      list: {
        title: 'Home Menu'
      },
      table: {
        logo: 'Logo',
        name: 'Menu Name',
        seq: 'Sort',
        isShow: 'Display',
        createTime: 'Create Time'
      },
      button: {
        addHouseKeep: 'Housekeeping Type Menu',
        addService: 'Housekeeping Menu',
        addCategory: 'Product Category',
        addShop: 'Product Menu',
        addMenu: 'External Menu'
      },
      form: {
        name: 'Menu Name',
        namePlaceholder: 'Please enter menu name',
        logo: 'Logo',
        url: 'URL',
        urlPlaceholder: 'Optional, please enter URL',
        housekeepingType: 'Service Type',
        housekeepingTypePlaceholder: 'Required, please select service type',
        housekeepingService: 'Housekeeping Service',
        housekeepingServicePlaceholder: 'Required, please select housekeeping service',
        product: 'Product',
        productPlaceholder: 'Required, please select product',
        category: 'Product Category',
        categoryPlaceholder: 'Required, please select product category',
        seq: 'Sort',
        seqPlaceholder: 'Required, please enter sort number',
        isShow: 'Display Status',
        isShowPlaceholder: 'Required, please select display status'
      },
      validate: {
        nameRequired: 'Menu name is required',
        nameMaxLength: 'Menu name is too long',
        logoRequired: 'Logo is required',
        housekeepingTypeRequired: 'Service type is required',
        housekeepingServiceRequired: 'Housekeeping service is required',
        productRequired: 'Product is required',
        categoryRequired: 'Product category is required',
        seqRequired: 'Sort is required',
        seqNumber: 'Sort must be a number',
        isShowRequired: 'Display status is required',
        menuIdRequired: 'Menu ID is required'
      },
      add: {
        title: 'Add Menu',
        success: 'Add menu successfully',
        error: 'Failed to add menu'
      },
      addHouseKeep: {
        title: 'Add Housekeeping Type Menu',
        success: 'Add housekeeping type menu successfully',
        error: 'Failed to add housekeeping type menu'
      },
      addService: {
        title: 'Add Housekeeping Menu',
        success: 'Add housekeeping menu successfully',
        error: 'Failed to add housekeeping menu'
      },
      addShop: {
        title: 'Add Product Menu',
        success: 'Add product menu successfully',
        error: 'Failed to add product menu'
      },
      addCategory: {
        title: 'Add Product Category Menu',
        success: 'Add product category menu successfully',
        error: 'Failed to add product category menu'
      },
      edit: {
        title: 'Edit Menu',
        success: 'Edit menu successfully',
        error: 'Failed to edit menu'
      },
      delete: {
        title: 'Delete Confirmation',
        confirmText: 'Are you sure to delete this menu?',
        success: 'Delete menu successfully',
        error: 'Failed to delete menu'
      },
      fetchError: 'Failed to fetch menu data'
    }
  },
  zh: {
    indexMenu: {
      search: {
        title: '查询条件',
        name: '菜单名称',
        isShow: '是否展示'
      },
      list: {
        title: '首页菜单'
      },
      table: {
        logo: '图标',
        name: '菜单名称',
        seq: '排序',
        isShow: '是否显示',
        createTime: '创建时间'
      },
      button: {
        addHouseKeep: '家政类型菜单',
        addService: '家政菜单',
        addCategory: '商品分类',
        addShop: '商品菜单',
        addMenu: '站外菜单'
      },
      form: {
        name: '菜单名称',
        namePlaceholder: '请输入菜单名称',
        logo: '图标',
        url: 'URL',
        urlPlaceholder: '选填，请填写URL',
        housekeepingType: '服务类型',
        housekeepingTypePlaceholder: '必填，请选择服务类型',
        housekeepingService: '家政服务',
        housekeepingServicePlaceholder: '必填，请选择家政服务',
        product: '商品',
        productPlaceholder: '必填，请选择商品',
        category: '商品分类',
        categoryPlaceholder: '必填，请选择商品分类',
        seq: '排序',
        seqPlaceholder: '必填，请填写排序',
        isShow: '是否显示',
        isShowPlaceholder: '必填，请选择是否显示'
      },
      validate: {
        nameRequired: '菜单名称不能为空',
        nameMaxLength: '菜单名称太长',
        logoRequired: '图标不能为空',
        housekeepingTypeRequired: '服务类型不能为空',
        housekeepingServiceRequired: '家政服务不能为空',
        productRequired: '商品不能为空',
        categoryRequired: '商品分类不能为空',
        seqRequired: '排序不能为空',
        seqNumber: '排序必须是数字',
        isShowRequired: '是否显示不能为空',
        menuIdRequired: '菜单ID不能为空'
      },
      add: {
        title: '添加菜单',
        success: '添加菜单成功',
        error: '添加菜单失败'
      },
      addHouseKeep: {
        title: '添加家政类型菜单',
        success: '添加家政类型菜单成功',
        error: '添加家政类型菜单失败'
      },
      addService: {
        title: '添加家政菜单',
        success: '添加家政菜单成功',
        error: '添加家政菜单失败'
      },
      addShop: {
        title: '添加商品菜单',
        success: '添加商品菜单成功',
        error: '添加商品菜单失败'
      },
      addCategory: {
        title: '添加商品分类菜单',
        success: '添加商品分类菜单成功',
        error: '添加商品分类菜单失败'
      },
      edit: {
        title: '修改菜单',
        success: '修改菜单成功',
        error: '修改菜单失败'
      },
      delete: {
        title: '删除确认',
        confirmText: '确定要删除该菜单吗？',
        success: '删除菜单成功',
        error: '删除菜单失败'
      },
      fetchError: '获取菜单数据失败'
    }
  }
}